Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "DropdownBase3700781160",
  {"root":"DropdownBase3700781160--root"},
  ".DropdownBase3700781160--root .Popover2254595937--popoverContent{overflow:hidden;min-width:192px;width:100%}.DropdownBase3700781160--root[data-dropdownbase3700781160-withwidth] .Popover2254595937--popoverContent{min-width:inherit;width:inherit}.DropdownBase3700781160--root[data-dropdownbase3700781160-witharrow] .Popover2254595937--popover[data-placement*=bottom] .Popover2254595937--popoverContent,.DropdownBase3700781160--root[data-dropdownbase3700781160-witharrow] .Popover2254595937--popover[data-placement*=top] .Popover2254595937--popoverContent{padding:10px 0}",
  8,
  "DropdownBase3700781160"
);
__webpack_require__.stylable.$.register(exports.default)
